var SET_DELIMITER = ",",
  REPLACEMENT_CHARACTER = "'";

function jsonToCSV(items, delimiter, replacementCharacter, excludedProps = []) {
  SET_DELIMITER = delimiter ?? SET_DELIMITER;
  REPLACEMENT_CHARACTER = replacementCharacter ?? REPLACEMENT_CHARACTER;

  let headers = getHeaders(items[0], excludedProps);

  let body = combineItems(headers, items);

  let csv = generateCSV(headers, body);

  return csv;
}

function getHeaders(object, excludedProps) {
  let headers = [];
  for (let key in object) {
    if (object.hasOwnProperty(key) && !excludedProps.includes(key)) {
      if (typeof object[key] === "object" && object[key] !== null) {
        headers.push([key].concat(getHeaders(object[key], [])));
      } else {
        headers.push(key);
      }
    }
  }
  return headers;
}

function transformHeader(fieldName) {
  let headerLabel = fieldName
    .toString()
    .replace('"', REPLACEMENT_CHARACTER)
    .replace(/([a-z])([A-Z])/g, "$1 $2");
  let header = headerLabel.charAt(0).toUpperCase() + headerLabel.slice(1);
  return `"${header}"`;
}

function transformField(field) {
  if (field == null) return `""`;

  return `"${field.toString().replace('"', REPLACEMENT_CHARACTER)}"`;
}

function getRow(headers, item) {
  let row = headers.map(header => {
    if (Array.isArray(header)) {
      return getRow(header.slice(1), item[header[0]]);
    }
    return transformField(item[header]);
  });

  return row.join(SET_DELIMITER);
}

function getHearderRow(headers, key = "") {
  let row = headers.map(header => {
    if (Array.isArray(header)) {
      return getHearderRow(header.slice(1), `${header[0]}.`);
    }
    return transformHeader(`${key}${header}`);
  });
  return row.join(SET_DELIMITER);
}

function combineItems(headers, items) {
  let rows = items.map(item => getRow(headers, item));
  return rows.join("\n");
}

function generateCSV(headers, body) {
  let headerRow = getHearderRow(headers);

  if (body == null || body == "") return headerRow;

  return headerRow + "\n" + body;
}

export default { jsonToCSV };
